<script>
    import _ from 'lodash'
    import UserService from '@/request/user/user'
    import ConsultationService from '@/request/record/consultation'
    export default {
        name: 'RecordConsultationEdit',
        components: {},
        props: {
            value: {
                type: Object,
                default () {
                    return {}
                }
            },
            showButtons: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                consultation: {
                    id: null,
                    recordId: null,
                    reason: null
                },
                back: {
                    id: null,
                    recordId: null,
                    reason: null
                },
                participatorSelected: [],
                participators: [],
                participatorLoading: false,
                participatorSelection: [],
                hostSelection: [],
                saving: false
            }
        },
        created () {
            this.init()
        },
        computed: {},
        mounted () {},
        watch: {
            value () {
                this.init()
            }
        },
        methods: {
            init () {
                this.consultation.id = this.value.id || null
                this.consultation.recordId = this.value.recordId || null
                this.consultation.reason = this.value.reason || null
                this.back.id = this.value.id || null
                this.back.recordId = this.value.recordId || null
                this.back.reason = this.value.reason || null
                this.listHost()
                this.listParticipator()
            },
            listParticipator () {
                this.participators = []
                this.participatorSelected = []
                if (!this.consultation.id) {
                    return
                }
                ConsultationService.listParticipator({
                    crid: this.consultation.id
                }).then(res => {
                    this.participators = _.clone(res.result || [])
                    let selecteds = []
                    _.forEach(this.participators, value => {
                        selecteds.push(value.participator)
                    })
                    this.participatorSelected = _.clone(selecteds)
                    this.back.pators = _.join(this.participatorSelected)
                })
            },
            listHost () {
                ConsultationService.listConsultationParticipatorHost().then(res => {
                    this.hostSelection = _.cloneDeep(res.result || [])
                })
            },
            listParticipatorSelection (query) {
                let self = this
                if (!query || query.length < 2) {
                    self.participatorSelection = []
                    return
                }
                self.participatorLoading = true
                UserService.find({
                    pageOffset: 1,
                    pageSize: 100
                }, {
                    match: query
                }).then(res => {
                    let data = res.result['content'] || []
                    self.participatorSelection = _.cloneDeep(data)
                }).catch(() => {
                    self.participatorSelection = []
                }).finally(() => {
                    self.participatorLoading = false
                })
            },
            handleCancle () {
                this.$emit('cancle')
            },
            save () {
                let con = _.cloneDeep(this.consultation)
                con.pators = _.join(this.participatorSelected)
                if (_.isEqual(con, this.back)) {
                    this.$emit('saveDone')
                    return
                }
                ConsultationService.save(con).then(res => {
                    _.assign(this.consultation, res.result)
                    con = _.defaultsDeep(this.consultation, this.value)
                    this.$emit('input', con)
                    this.$emit('saveDone')
                })
            }
        }
    }
</script>

<template>
    <el-form ref="form" :model="consultation" :disabled="saving" @keyup.enter.native="save">
        <el-form-item label="参与会诊" prop="participatorSelected">
            <el-select
                    v-model="participatorSelected"
                    clearable
                    multiple
                    filterable
                    remote
                    default-first-option
                    placeholder="选择参与会诊的医生或输入医生姓名查找"
                    :remote-method="listParticipatorSelection"
                    :loading="participatorLoading"
                    @focus="listParticipatorSelection()"
                    style="width: 100%;">
                <el-option-group label="会诊医生">
                    <el-option
                            v-for="item in participatorSelection"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-option-group>
                <el-option-group label="常用医生">
                    <el-option
                            v-for="item in hostSelection"
                            :key="item.pator"
                            :label="item.name"
                            :value="item.pator"
                    ></el-option>
                </el-option-group>
            </el-select>
        </el-form-item>
        <el-form-item label="会诊原因">
            <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="consultation.reason" placeholder="发起这次会诊的原因"></el-input>
        </el-form-item>
        <el-form-item v-if="showButtons">
            <el-button type="primary" @click="save">确定</el-button>
            <el-button @click="handleCancle">取消</el-button>
        </el-form-item>
    </el-form>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
